import { patchRequest } from '@/core';
import { vendors } from '@/requests';

export default async function updateVendorRequest(id, patch) {
	let url = vendors.getByIdPath(id);
	let response = await patchRequest(url, {}, { patch });
	return response;
}
